import EditBankInfoModal from '../MainScreen/AccountVerifyScreen/EditBankInfoModal';
import ActiveAccountModal from './ActiveAccountModal';
import ControlEKYCScreen from './ControlEKYCScreen';
import ReviewInfoModal from './ControlEKYCScreen/ReviewInfoModal';
import ForgotPasswordScreen from './ForgotPasswordScreen';
import LoginScreen from './LoginScreen';
import OtpRequestModal from './OtpRequestModal';
import RegisterScreen from './RegisterScreen';
import SetPasswordScreen from './SetPasswordScreen';
import OverviewScreen from '../MainScreen/OverviewScreen';

const screens: any = {
  LoginScreen,
  RegisterScreen,
  ForgotPasswordScreen,
  OtpRequestModal,
  SetPasswordScreen,
  ControlEKYCScreen,
  ActiveAccountModal,
  EditBankInfoModal,
  ReviewInfoModal,
  OverviewScreen,
};

const stackUnAuthorizedScreen = Object.keys(screens)
  .filter(a => !a.includes('modal') && !a.includes('Modal'))
  .map(item => {
    return {
      name: item,
      component: screens?.[item],
    };
  });
const stackUnAuthorizedModal = Object.keys(screens)
  .filter(a => !a.includes('screen') && !a.includes('Screen'))
  .map(item => {
    return {
      name: item,
      component: screens?.[item],
    };
  });

export {stackUnAuthorizedModal, stackUnAuthorizedScreen};
